import axios from "axios";
import { getDefaultConfigHeader } from "../../Utils/headerDefaultConfigPetition";

const url = process.env.REACT_APP_API_BACKEND + "/employee";

export type EmployeeOrderBy =
  | "id"
  | "name"
  | "surname"
  | "email"
  | "display_name"
  | "id_rol"
  | "active"
  | "created_at";

export type EmployeeListParams = {
  search?: string;
  id_rol?: number | string;
  active?: boolean | string;
  order_by?: EmployeeOrderBy;
  order_dir?: "asc" | "desc";
  page: number; // empieza en 1
  page_size: number; // de 1 a 100
};

// Respuesta: { items, total, page, page_size, pages }
export const getEmployees = (params: EmployeeListParams) =>
  axios.get(url, { ...getDefaultConfigHeader(), params });

// Usuario actual con su rol y permisos (para refrescarlos sin volver a hacer login)
export const getCurrentEmployee = () => axios.get(url + "/me", getDefaultConfigHeader());

// Incluye los permisos efectivos del usuario (permissions)
export const getEmployee = (id: number) => axios.get(`${url}/${id}`, getDefaultConfigHeader());

export const addEmployee = (employee: any) => axios.post(url, employee, getDefaultConfigHeader());

// Parcial: solo los campos que cambian
export const updateEmployee = (id: number, changes: any) =>
  axios.put(`${url}/${id}`, changes, getDefaultConfigHeader());

export const setEmployeeActive = (id: number, active: boolean) =>
  axios.patch(`${url}/${id}/active`, { active }, getDefaultConfigHeader());

export const deleteEmployee = (id: number) => axios.delete(`${url}/${id}`, getDefaultConfigHeader());
